module.exports = __webpack_public_path__ + "media/images/flags/16/Equatorial-Guinea-3c9bbdef466d8ad4a7c8d65bb85069ce.png";